export const advancedVerbFormQuestions = [
  {
    id: 1,
    koreanQuestion: "고객들은 미리 예약한 영업시간 외에 연락될 것입니다 ____ ",
    question:
      "Customers with pre-scheduled appointments outside the new business hours will be contacted ______.",
    choices: {
      A: "suddenly",
      B: "clearly",
      C: "individually",
      D: "upward",
    },
    correctAnswer: "C",
    explanation:
      "A: suddenly (갑자기) B: clearly (명확하게) C: individually (개별적으로) D: upward (위쪽으로) 중간에 수식이 많으나 결론적으론 '고객들은 연락될 것이다 개인적으로'라고 화자의 ",
    translation:
      "새로운 영업 시간 외에 사전 예약된 고객들은 개별적으로 연락을 받을 것입니다.",
    type: "adverb usage",
  },
  {
    id: 2,
    koreanQuestion: "수도 공급이 일시적으로 차단될 것입니다 영향을 받는 층에서",
    question:
      "Water supply will be temporarily shut off ______ affected floors.",
    choices: {
      A: "over",
      B: "on",
      C: "by",
      D: "under",
    },
    correctAnswer: "B",
    explanation:
      "A: over (위에) B: on (~에) C: by (~에 의해) D: under (아래에) - 이 문제는 전치사 사용에 관한 것입니다. '영향을 받는 층에서'라는 표현에서 적절한 전치사는 'on'입니다. 'on the affected floors'는 '영향을 받는 층에서'라는 의미로, 특정 위치나 장소를 나타낼 때 사용됩니다.",
    translation: "수도 공급이 영향을 받는 층에서 일시적으로 차단될 것입니다.",
    type: "preposition usage",
  },
  {
    id: 3,
    koreanQuestion:
      "직원들 그.. 근무하는 영향을 받는 층에서 저장해야 한다 직원들의 작업을 사전에 미리 전력중단 _____",
    question:
      "Employees working on the affected floors should save their work in advance ______ power disruptions.",
    choices: {
      A: "in case of",
      B: "in spite of",
      C: "unlike",
      D: "instead of",
    },
    correctAnswer: "A",
    explanation:
      "A: in case of (전력중단에 대비하여) B: in spite of (전력중단에도 불구하고) C: unlike (전력중단과는 달리) D: instead of (전력중단 대신에). 이 문제는 전치사구의 의미를 이해하면 풀 수 있습니다. 'in case of power disruptions'는 '전력 중단에 대비하여'라는 의미로, 미리 예방 조치를 취하는 상황에 적합합니다.",
    translation:
      "영향을 받는 층에서 근무하는 직원들은 전력 중단에 대비하여 미리 작업을 저장해야 합니다.",
    type: "preposition usage",
  },
  {
    id: 4,
    koreanQuestion:
      "세입자들은 권고됩니다 사용하도록 대체 주차 공간을 유지보수 기간 _____ ",
    question:
      "Tenants are advised to use alternative parking spaces ______ the maintenance period.",
    choices: {
      A: "during",
      B: "despite",
      C: "until",
      D: "without",
    },
    correctAnswer: "A",
    explanation:
      "A: during (유지보수 기간 동안) B: despite (유지보수 기간에도 불구하고) C: until (유지보수 기간까지) D: without (유지보수 기간 없이). 이 문제는 전치사 사용에 관한 것입니다. '유지보수 기간 동안'이라는 표현에 적절한 전치사는 'during'입니다.",
    translation:
      "세입자들은 유지보수 기간 동안 대체 주차 공간을 사용하도록 권고됩니다.",
    type: "preposition usage",
  },
  {
    id: 5,
    koreanQuestion:
      "사용자들 그... 요구하는 추가적 시간을 요청해야 한다 연장을 사서로부터, 그... ______ 허가될 것입니다 가용성에 따라.",
    question:
      "Users who require additional time must request an extension from a librarian, will be granted based on availability.",
    choices: {
      A: "who",
      B: "where",
      C: "which",
      D: "what",
    },
    correctAnswer: "C",
    explanation:
      "A: who (사람을 지칭하는 관계대명사) B: where (장소를 지칭하는 관계부사) C: which (사물을 지칭하는 관계대명사) D: what (선행사를 포함한 관계대명사). 여기서는 'extension(연장)'이라는 사물을 지칭하는 관계대명사 'which'가 적절합니다. '연장이 가용성에 따라 허가될 것이다'라는 의미를 나타냅니다.",
    translation:
      "추가 시간이 필요한 이용자는 사서에게 연장을 요청해야 하며, 이는 가용성에 따라 허가됩니다.",
    type: "relative pronoun",
  },
  {
    id: 6,
    koreanQuestion:
      "관리 직원들은 (미래에) 지원하고 있을 것이다 그리고 ______ 것이다 눈을 하루종일 ",
    question:
      "Maintenance staff will be applying salt and ______ snow throughout the day.",
    choices: {
      A: "clear",
      B: "clearly",
      C: "clearance",
      D: "clearing",
    },
    correctAnswer: "D",
    explanation:
      "지원하는 중일 것이다 그리고 치우는 중일 것이다 (will be applying and will be clearing).",
    translation: "관리 직원들은 하루 종일 소금을 뿌리고 눈을 치울 것입니다.",
    type: "verb form",
  },
  {
    id: 7,
    koreanQuestion:
      "당신의 참여는 ______ 합니다 형성하는데 미래를 우리 지역사회의",
    question:
      "Your participation is ______ in shaping the future of our community.",
    choices: {
      A: "eventual",
      B: "essential",
      C: "external",
      D: "experimental",
    },
    correctAnswer: "B",
    explanation: "A: 결국 일어나는 B: 필수적인 C: 외부의 D: 실험적인.",
    translation:
      "당신의 참여는 우리 지역사회의 미래를 형성하는 데 필수적입니다.",
    type: "adjective usage",
  },
  {
    id: 8,
    koreanQuestion:
      "직원들은 그... 등록하는 카풀링에 받을것이다 우선 주차 공간을 그리고 월간 교통 보조금을",
    question:
      "Employees ______ register for carpooling will receive priority parking spaces and a monthly transportation subsidy.",
    choices: {
      A: "which",
      B: "who",
      C: "where",
      D: "what",
    },
    correctAnswer: "B",
    explanation:
      "그.. 앞은 직원들(사람)이고 그.. 뒤에는 ____ 등록하다 카풀에, 주격자리가 비어있음으로 who가 답입니다.",
    translation:
      "카풀에 등록하는 직원들은 우선 주차 공간과 월간 교통 보조금을 받을 것입니다.",
    type: "relative pronoun",
  },
  {
    id: 9,
    koreanQuestion:
      "10월 15일 2025년부터, 우리는 (미래에) 시행 중일 것이다 업데이트를 우리의 은행 거래 정책에 대해 향상시키기 위해 보안과 고객 편의성을.",
    question:
      "______ October 15, 2025, we will be implementing updates to our banking transaction policies to enhance security and customer convenience.",
    choices: {
      A: "Starting",
      B: "Across",
      C: "Despite",
      D: "Under",
    },
    correctAnswer: "A",
    explanation:
      "A: ~부터 시작하여 B: ~을 가로질러, ~에 걸쳐 C: ~에도 불구하고 D: ~아래에. 여기서는 특정 날짜부터 시작하는 것을 나타내므로 'Starting'이 적절합니다.",
    translation:
      "2025년 10월 15일부터, 우리는 보안과 고객 편의성을 향상시키기 위해 은행 거래 정책에 대한 업데이트를 시행할 예정입니다.",
    type: "preposition usage",
  },
  {
    id: 10,
    koreanQuestion:
      "우리는 기쁩니다 발표하게 되어 그.. 새로운 유연 근무 정책이 시행될 것임을 ____ 4월 1일 2025년, 향상시키기 위해 직원들의 일과 삶의 균형을.",
    question:
      "We are pleased to announce that a new Flexible Work Policy will be implemented ______ April 1, 2025, to enhance employee work-life balance.",
    choices: {
      A: "starting",
      B: "start",
      C: "started",
      D: "starts",
    },
    correctAnswer: "A",
    explanation:
      "A: ~부터 시작하여(현재분사) B: 시작하다(동사원형) C: 시작했다(과거형) D: 시작한다(3인칭 단수 현재형). 여기서는 특정 날짜부터 정책이 시행됨을 나타내므로 'starting'이 적절합니다.",
    translation:
      "우리는 직원들의 일과 삶의 균형을 향상시키기 위해 2025년 4월 1일부터 새로운 유연 근무 정책이 시행될 것임을 기쁘게 발표합니다.",
    type: "preposition usage",
  },
  {
    id: 11,
    koreanQuestion:
      "실패는 준수하는 것을 이러한 정책을 결과를 낼 수 있다 제한된 접근 또는 징계 조치를.",
    question:
      "Failure to comply with these policies may result ______ restricted access or disciplinary action.",
    choices: {
      A: "in",
      B: "for",
      C: "by",
      D: "with",
    },
    correctAnswer: "A",
    explanation:
      "A: ~에 있어서, ~의 결과로 B: ~을 위해 C: ~에 의해 D: ~와 함께. 여기서는 'result in'이라는 구문이 사용되었는데, 이는 '~의 결과를 초래하다'라는 의미로 'in'이 올바른 전치사입니다.",
    translation:
      "이러한 정책을 준수하지 않을 경우 제한된 접근이나 징계 조치를 받을 수 있습니다.",
    type: "preposition usage",
  },
  {
    id: 12,
    koreanQuestion:
      "우리는 현재 찾고 있습니다 ______ 의욕이 높은 마케팅 코디네이터를 지원하기 위해 우리의 성장하는 비즈니스를.",
    question:
      "We are currently seeking a ______ motivated Marketing Coordinator to support our growing business.",
    choices: {
      A: "mostly",
      B: "nearly",
      C: "highly",
      D: "lately",
    },
    correctAnswer: "C",
    explanation:
      "A: 대부분, 주로 B: 거의 C: 매우, 높이 D: 최근에. 여기서는 '매우 의욕적인(highly motivated)'이라는 표현이 적절합니다. 'highly'는 정도를 나타내는 부사로 '매우, 높은 수준으로'의 의미를 가집니다.",
    translation:
      "우리는 현재 성장하는 비즈니스를 지원할 매우 의욕이 높은 마케팅 코디네이터를 찾고 있습니다.",
    type: "adverb usage",
  },
  {
    id: 13,
    koreanQuestion:
      "방문객들은 투어 예약이 있는 통지받을 것이다 어떤 변화들을 이메일을 통해 최소 48시간 사전에.",
    question:
      "Visitors with tour reservations will be notified of any changes ______ email at least 48 hours in advance.",
    choices: {
      A: "across",
      B: "under",
      C: "via",
      D: "despite",
    },
    correctAnswer: "C",
    explanation:
      "A: 가로질러, 건너서 B: ~아래에 C: ~을 통해, ~을 경유하여 D: ~에도 불구하고. 여기서는 '이메일을 통해(via email)' 통지한다는 의미이므로 'via'가 올바른 전치사입니다.",
    translation:
      "투어 예약이 있는 방문객들은 변경 사항이 있을 경우 최소 48시간 전에 이메일을 통해 통지받을 것입니다.",
    type: "preposition usage",
  },
  {
    id: 14,
    koreanQuestion:
      "축제가 끝날 때 까지, 모든 열차들은 (미래에) 운행중일 것이다 감소된 속도로 그리고 경험할지도 모른다 약간의 지연을 링컨 스퀘어와 제퍼슨 애비뉴 역 사이에서.",
    question:
      "______ the festival concludes, all trains will be operating at reduced speeds and may experience slight delays between Lincoln Square and Jefferson Avenue Stations.",
    choices: {
      A: "Despite",
      B: "Unless",
      C: "Until",
      D: "Because",
    },
    correctAnswer: "C",
    explanation:
      "A: ~에도 불구하고 B: ~하지 않는 한 C: ~할 때까지 D: ~때문에. 여기서는 '축제가 끝날 때까지(Until the festival concludes)' 열차가 감속 운행된다는 의미이므로 'Until'이 올바른 접속사입니다.",
    translation:
      "축제가 끝날 때까지, 모든 열차는 감속 운행될 것이며 링컨 스퀘어와 제퍼슨 애비뉴 역 사이에서 약간의 지연이 발생할 수 있습니다.",
    type: "conjunction usage",
  },
  {
    id: 15,
    koreanQuestion:
      "개선하기 위해 서비스를 피크시간 동안, ______ 열차들이 (미래에) 운행 중일 것이다 그린 라인에서 다음주 월요일부터.",
    question:
      "To improve service during peak hours, ______ trains will be running on the Green Line starting next Monday.",
    choices: {
      A: "accidental",
      B: "optional",
      C: "additional",
      D: "historical",
    },
    correctAnswer: "C",
    explanation:
      "A: 우연한, 사고의 B: 선택적인 C: 추가적인 D: 역사적인. 여기서는 '추가 열차(additional trains)'가 운행된다는 의미가 문맥상 적절합니다. 서비스 개선을 위해 더 많은 열차를 투입한다는 의미입니다.",
    translation:
      "피크 시간대 서비스를 개선하기 위해, 추가 열차들이 다음 월요일부터 그린 라인에서 운행될 것입니다.",
    type: "adjective usage",
  },
  {
    id: 16,
    koreanQuestion:
      "만약 당신의 반려동물이 보인다면 징후를 공격성의, 우리는 권장합니다 ______ 입마개를 또는 피하는 것을  붐비는 지역을",
    question:
      "If your pet shows signs of aggression, we recommend ______ a muzzle or avoiding crowded areas.",
    choices: {
      A: "to use",
      B: "use",
      C: "using",
      D: "used",
    },
    correctAnswer: "C",
    explanation:
      "A: 사용하기 위해 B: 사용하다 C: 사용하는 것 D: 사용된. 'recommend' 동사 뒤에는 동명사(gerund)가 오는 것이 문법적으로 올바릅니다. 따라서 'using'이 정답입니다.",
    translation:
      "만약 당신의 반려동물이 공격성의 징후를 보인다면, 우리는 입마개를 사용하거나 붐비는 지역을 피하는 것을 권장합니다.",
    type: "gerund usage",
  },
  {
    id: 17,
    koreanQuestion:
      "그의 ______ 주의는 세부사항에 대한 그리고 전략적 리더십은 (현재) 지속적으로 결과를 냈다 높은 효율성과 향상된 고객 충성도를.",
    question:
      "His ______ attention to detail and strategic leadership have consistently resulted in higher efficiency and improved customer loyalty.",
    choices: {
      A: "general",
      B: "careless",
      C: "keen",
      D: "occasional",
    },
    correctAnswer: "C",
    explanation:
      "A: 일반적인 B: 부주의한 C: 예리한, 날카로운 D: 가끔의. 여기서는 '예리한 주의력(keen attention)'이 문맥상 가장 적절합니다. 세부 사항에 대한 예리한 주의력과 전략적 리더십이 효율성과 고객 충성도 향상으로 이어졌다는 의미입니다.",
    translation:
      "그의 예리한 세부 사항에 대한 주의와 전략적 리더십은 일관되게 높은 효율성과 향상된 고객 충성도로 이어졌습니다.",
    type: "adjective usage",
  },
  {
    id: 18,
    koreanQuestion:
      "추가적으로, 일부는 자금  _____ 것이다 시작하는 데 지역사회 아웃리치 프로그램을, 장려하며 의료 전문가들이 제공하도록 자원봉사 서비스를",
    question:
      "Additionally, a portion of the funds will be ______ to launching community outreach programs, encouraging medical professionals to offer volunteer services.",
    choices: {
      A: "decorated",
      B: "delivered",
      C: "dedicated",
      D: "damaged",
    },
    correctAnswer: "C",
    explanation:
      "A: 장식된 B: 배달된 C: 할당된, 지정된, 전념된 D: 손상된. 여기서는 '할당된, 전념된(dedicated)'이 문맥상 가장 적절합니다. 자금의 일부가 특정 목적(지역사회 아웃리치 프로그램 시작)에 할당되거나 전념된다는 의미입니다.",
    translation:
      "추가적으로, 자금의 일부는 지역사회 아웃리치 프로그램을 시작하는 데 전념될 것이며, 의료 전문가들이 자원봉사 서비스를 제공하도록 장려할 것입니다.",
    type: "verb usage",
  },
  {
    id: 19,
    koreanQuestion:
      "티켓은 사용될 것이다 80달러에 1인당, 그리고 모든 _____ 은 직접 자금을 지원할 것이다 장학금 프로그램에",
    question:
      "Tickets will be available for $80 per person, and all ______ will directly fund scholarship programs.",
    choices: {
      A: "requirements",
      B: "proceeds",
      C: "appointments",
      D: "suggestions",
    },
    correctAnswer: "B",
    explanation:
      "A: 요구사항 B: 수익금 C: 약속, 예약 D: 제안. 여기서는 '수익금(proceeds)'이 문맥상 가장 적절합니다. 티켓 판매로 얻은 수익금이 장학금 프로그램에 사용된다는 의미입니다.",
    translation:
      "티켓은 1인당 $80에 판매될 것이며, 모든 수익금은 장학금 프로그램에 직접 기금으로 사용될 것입니다.",
    type: "noun usage",
  },
  {
    id: 20,
    koreanQuestion: "내일의 기자 회견에서, 회사는 _____ 것이다 재설계된 로고를",
    question:
      "At tomorrow's press conference, the company will ______ its redesigned logo.",
    choices: {
      A: "unveil",
      B: "unravel",
      C: "ungain",
      D: "unwind",
    },
    correctAnswer: "A",
    explanation:
      "A: 공개하다, 베일을 벗기다 B: 풀다, 해명하다 C: 'ungain'은 일반적으로 사용되지 않는 단어 D: 풀다, 긴장을 풀다. 여기서는 '공개하다(unveil)'가 문맥상 가장 적절합니다. 회사가 새로 디자인된 로고를 처음으로 대중에게 보여준다는 의미입니다.",
    translation:
      "내일의 기자 회견에서, 회사는 재설계된 로고를 공개할 것입니다.",
    type: "verb usage",
  },
  {
    id: 21,
    koreanQuestion:
      "7월 10일부터 여러 버스 노선들이 일시적으로 조정될 것이다 _____ 도로 유지보수로 인해 시내의.",
    question:
      "Starting July 10, several bus routes will be temporarily adjusted due to ______ road maintenance in the downtown area.",
    choices: {
      A: "completed",
      B: "frequent",
      C: "scheduled",
      D: "delayed",
    },
    correctAnswer: "C",
    explanation:
      "A: 완료된 B: 빈번한 C: 예정된 D: 지연된. 여기서는 '예정된(scheduled)'이 문맥상 가장 적절합니다. 미래에 계획된 도로 유지보수 작업으로 인해 버스 노선이 조정된다는 의미입니다.",
    translation:
      "7월 10일부터 시내 지역의 예정된 도로 유지보수로 인해 여러 버스 노선이 일시적으로 조정될 예정입니다.",
    type: "adjective usage",
  },
  {
    id: 22,
    koreanQuestion:
      "이 필요한 프로젝트는 목표로 한다 개선하도록 도로 상태를 그리고 향상시키도록 전반적인 교통 흐름을, 보장하며 _______ 그리고 더 원할한 통근을 모든 승객들에게",
    question:
      "This necessary project aims to improve road conditions and enhance overall traffic flow, ensuring a ______ and smoother commute for all passengers.",
    choices: {
      A: "longer",
      B: "heavier",
      C: "safer",
      D: "slower",
    },
    correctAnswer: "C",
    explanation:
      "A: 더 긴 B: 더 무거운 C: 더 안전한 D: 더 느린. 여기서는 '더 안전한(safer)'이 문맥상 가장 적절합니다. 도로 상태 개선과 교통 흐름 향상의 목적은 승객들에게 더 안전하고 원활한 통근을 제공하는 것입니다.",
    translation:
      "이 필요한 프로젝트는 도로 상태를 개선하고 전반적인 교통 흐름을 향상시키는 것을 목표로 하며, 모든 승객들에게 더 안전하고 더 원활한 통근을 보장합니다.",
    type: "adjective usage",
  },
  {
    id: 23,
    koreanQuestion:
      "승객들은 권장됩니다 확인하도록 업데이트된 일정을 그리고 ______  추가 이동 시간을 지연을 피하기 위해",
    question:
      "Passengers are advised to check updated schedules and ______ extra travel time to avoid delays.",
    choices: {
      A: "allow",
      B: "consume",
      C: "demand",
      D: "reduce",
    },
    correctAnswer: "A",
    explanation:
      "A: 확보하다, 허용하다 B: 소비하다 C: 요구하다 D: 줄이다. 여기서는 '확보하다, 허용하다(allow)'가 문맥상 가장 적절합니다. 지연을 피하기 위해 승객들은 추가 이동 시간을 확보하라는 조언을 받고 있습니다.",
    translation:
      "승객들은 지연을 피하기 위해 업데이트된 일정을 확인하고 추가 이동 시간을 확보하는 것이 좋습니다.",
    type: "verb usage",
  },
  {
    id: 24,
    koreanQuestion:
      "8월 1일부터 2층은 에버그린 쇼핑몰 진행할 예정이다 _______ 레노베이션을 제공하기 위해 더 현대적이고 즐거운 쇼핑 경험을",
    question:
      "Starting August 1, the second floor of Evergreen Shopping Mall will undergo ______ renovations to provide a more modern and enjoyable shopping experience.",
    choices: {
      A: "accidental",
      B: "noisy",
      C: "minor",
      D: "extensive",
    },
    correctAnswer: "D",
    explanation:
      "A: 우연한 B: 시끄러운 C: 사소한 D: 광범위한. 여기서는 '광범위한(extensive)'이 문맥상 가장 적절합니다. 쇼핑몰의 2층이 더 현대적이고 즐거운 쇼핑 경험을 제공하기 위해 대규모 리노베이션을 진행한다는 의미입니다.",
    translation:
      "8월 1일부터 에버그린 쇼핑몰의 2층은 더 현대적이고 즐거운 쇼핑 경험을 제공하기 위해 광범위한 리노베이션을 진행할 예정입니다.",
    type: "adjective usage",
  },
  {
    id: 25,
    koreanQuestion:
      "리노베이션 기간 동안, 대부분 상점들은 2층에 있는  계속 열 것이다, 그러나 _______ 구역들은 제한 될 수 있습니다 접근이.",
    question:
      "During the renovation period, most stores on the second floor will remain open, but ______ sections may have restricted access.",
    choices: {
      A: "remote",
      B: "decorative",
      C: "spacious",
      D: "certain",
    },
    correctAnswer: "D",
    explanation:
      "A: 원격의 B: 장식적인 C: 넓은 D: 특정한. 여기서는 '특정한(certain)'이 문맥상 가장 적절합니다. 리노베이션 기간 동안 모든 구역이 아닌 특정 구역만 접근이 제한된다는 의미입니다.",
    translation:
      "리노베이션 기간 동안, 2층의 대부분 상점들은 계속 영업할 것이지만, 특정 구역들은 접근이 제한될 수 있습니다.",
    type: "adjective usage",
  },
  {
    id: 26,
    koreanQuestion:
      "저희는 (현재) 강화했습니다 우리의 보상 시스템을, 하게 하며 자주 이용하는 사용자들이 얻을 수 있게 크레딧을 그...  ______ 될 수 있는 할인된 요금과 우선 접근 권한으로",
    question:
      "We have enhanced our rewards system, allowing frequent users to earn credits that can be ______ for discounted rates and priority access.",
    choices: {
      A: "delayed",
      B: "donated",
      C: "expired",
      D: "redeemed",
    },
    correctAnswer: "D",
    explanation:
      "A: 지연된 B: 기부된 C: 만료된 D: 상환된, 교환된. 여기서는 '상환된, 교환된(redeemed)'이 문맥상 가장 적절합니다. 적립한 크레딧을 할인된 요금과 우선 접근 권한으로 교환할 수 있다는 의미입니다.",
    translation:
      "저희는 보상 시스템을 강화하여 자주 이용하는 사용자들이 할인된 요금과 우선 접근 권한으로 교환할 수 있는 크레딧을 적립할 수 있게 했습니다.",
    type: "verb usage",
  },
  {
    id: 27,
    koreanQuestion:
      "이러한 업데이트들은 설계되었습니다 만들기 위해 당신의 주차 경험을 더 편리하고, 효율적이며, 그리고  ______ 되도록 당신의 필요에",
    question:
      "These updates are designed to make your parking experience more convenient, efficient, and ______ to your needs.",
    choices: {
      A: "overwhelmed",
      B: "delayed",
      C: "complicated",
      D: "tailored",
    },
    correctAnswer: "D",
    explanation:
      "A: 압도된 B: 지연된 C: 복잡한 D: 맞춤화된. 여기서는 '맞춤화된(tailored)'이 문맥상 가장 적절합니다. 주차 경험이 사용자의 필요에 맞게 조정되었다는 의미입니다.",
    translation:
      "이러한 업데이트들은 주차 경험을 더 편리하고, 효율적이며, 당신의 필요에 맞춤화되도록 설계되었습니다.",
    type: "adjective usage",
  },
  {
    id: 28,
    koreanQuestion:
      "CEO는 ______ 전략적 계획을 이해관계자들에게 다음 월요일에.",
    question:
      "The CEO will ______ the strategic plan to stakeholders next Monday.",
    choices: {
      A: "outline",
      B: "outlive",
      C: "outline",
      D: "outline",
    },
    correctAnswer: "A",
    explanation:
      "A: 개요를 설명하다 B: ~보다 오래 살다 C: 개요를 설명하다 D: 개요를 설명하다. 여기서는 '개요를 설명하다(outline)'가 문맥상 가장 적절합니다. CEO가 이해관계자들에게 전략적 계획의 개요를 설명할 것이라는 의미입니다.",
    translation:
      "CEO는 다음 월요일에 이해관계자들에게 전략적 계획의 개요를 설명할 것입니다.",
    type: "verb usage",
  },
  {
    id: 29,
    koreanQuestion:
      "시티 아트 뮤지엄은 기쁩니다 발표하게 되어 그랜드 오프닝을 '비전스 오브 타임'의, 숨막히는 전시회 ______ 현대 예술가 다니엘 휘트모어의 , 토요일, 4월 20일, 오후 5시에.",
    question:
      "The City Art Museum is delighted to announce the grand opening of Visions of Time, a breathtaking exhibition by ______ contemporary artist Daniel Whitmore, on Saturday, April 20, at 5:00 P.M.",
    choices: {
      A: "struggling",
      B: "unknown",
      C: "retired",
      D: "renowned",
    },
    correctAnswer: "D",
    explanation:
      "A: 고군분투하는 B: 알려지지 않은 C: 은퇴한 D: 유명한, 명성 있는. 여기서는 '유명한, 명성 있는(renowned)'이 문맥상 가장 적절합니다. 미술관이 자랑스럽게 소개하는 전시회는 이미 명성이 있는 예술가의 작품일 가능성이 높습니다.",
    translation:
      "시티 아트 뮤지엄은 토요일, 4월 20일, 오후 5시에 유명한 현대 예술가 다니엘 휘트모어의 숨막히는 전시회인 '비전스 오브 타임'의 그랜드 오프닝을 발표하게 되어 기쁩니다.",
    type: "adjective usage",
  },
  {
    id: 30,
    koreanQuestion:
      "참가자들은 책임이 있습니다 가져올 그들의 자신의 재료들을 ______ 명시되지 않는 한 강사에 의해.",
    question:
      "Participants are responsible for bringing their own materials unless ______ specified by the instructor.",
    choices: {
      A: "before",
      B: "under",
      C: "across",
      D: "otherwise",
    },
    correctAnswer: "D",
    explanation:
      "A: 이전에 B: 아래에 C: 가로질러 D: 그렇지 않으면, 달리. 여기서는 '그렇지 않으면, 달리(otherwise)'가 문맥상 가장 적절합니다. '~하지 않는 한'이라는 의미로, 강사가 특별히 다른 지시를 하지 않는 한 참가자들이 자신의 재료를 가져와야 한다는 의미입니다.",
    translation:
      "참가자들은 강사에 의해 달리 명시되지 않는 한 자신의 재료를 가져올 책임이 있습니다.",
    type: "adverb usage",
  },
  {
    id: 31,
    koreanQuestion:
      "이 방들은 제공합니다 조용하고 편안한 환경을 학생들을 위해 그리고 전문가들을 위해 그... 필요한  _____ 공간이, 독서, 연구 또는 그룹 토론을 위해 ",
    question:
      "These rooms provide a quiet and comfortable environment for students and professionals who need a ______ space for reading, research, or group discussions.",
    choices: {
      A: "abandoned",
      B: "cluttered",
      C: "expired",
      D: "dedicated",
    },
    correctAnswer: "D",
    explanation:
      "A: 버려진 B: 어수선한, 혼잡한 C: 만료된 D: 전용의, 헌신적인. 여기서는 '전용의, 헌신적인(dedicated)'이 문맥상 가장 적절합니다. 학생들과 전문가들이 필요로 하는 것은 특정 목적을 위해 마련된 전용 공간입니다.",
    translation:
      "이 방들은 독서, 연구 또는 그룹 토론을 위한 전용 공간이 필요한 학생들과 전문가들에게 조용하고 편안한 환경을 제공합니다.",
    type: "adjective usage",
  },
  {
    id: 32,
    koreanQuestion:
      "도서관 장비는 이용가능하다  ______ 사용을 위해, 그러나 반환되어야 합니다 그것의 원래 상태로 각 세션 후에.",
    question:
      "Library equipment is available for ______ use, but must be returned in its original condition after each session.",
    choices: {
      A: "broken",
      B: "expired",
      C: "stolen",
      D: "shared",
    },
    correctAnswer: "D",
    explanation:
      "A: 고장난 B: 만료된 C: 도난당한 D: 공유된. 여기서는 '공유된(shared)'이 문맥상 가장 적절합니다. 도서관 장비는 여러 사람이 함께 사용할 수 있도록 공유되는 것이므로, 'shared use(공유 사용)'가 올바른 표현입니다.",
    translation:
      "도서관 장비는 공유 사용을 위해 이용 가능하지만, 각 세션 후에 원래 상태로 반환되어야 합니다.",
    type: "adjective usage",
  },
  {
    id: 33,
    koreanQuestion:
      "모든 직원들은 요청받습니다 도착하기를 회의실에 오전 9시 정각까지.",
    question:
      "All employees are requested to arrive at the conference room ______ 9:00 AM sharp.",
    choices: {
      A: "for",
      B: "by",
      C: "from",
      D: "until",
    },
    correctAnswer: "B",
    explanation:
      "A: ~을 위해 B: ~까지 C: ~부터 D: ~까지(기간). 여기서는 '~까지(by)'가 문맥상 가장 적절합니다. 'by'는 특정 시간까지 도착해야 함을 나타냅니다.",
    translation:
      "모든 직원들은 오전 9시 정각까지 회의실에 도착하도록 요청받습니다.",
    type: "preposition usage",
  },
  {
    id: 34,
    koreanQuestion:
      "예산 승인은 완료될 것입니다 4월 22일____ ,2025년, 실행과 함께 시작하는 5월 1일에, 2025.",
    question:
      "Budget approval will be completed ______ April 22, 2025, with implementation starting May 1, 2025.",
    choices: {
      A: "by",
      B: "during",
      C: "across",
      D: "despite",
    },
    correctAnswer: "A",
    explanation:
      "A: ~까지 B: ~동안 C: ~에 걸쳐 D: ~에도 불구하고. 여기서는 '~까지(by)'가 문맥상 가장 적절합니다. 'by'는 특정 시간이나 날짜까지 무언가가 완료될 것임을 나타냅니다.",
    translation:
      "예산 승인은 2025년 4월 22일까지 완료될 것이며, 실행은 2025년 5월 1일에 시작됩니다.",
    type: "preposition usage",
  },
  {
    id: 35,
    koreanQuestion:
      "출석은 필수입니다, 그리고 직원들은 그... 실패한 환료하는 것을 이 교육을 _____않을 것입니다. 특정 구역에 직장의.",
    question:
      "Attendance is mandatory, and employees who fail to complete this training will not be ______ to access certain areas of the workplace.",
    choices: {
      A: "denied",
      B: "welcomed",
      C: "forced",
      D: "permitted",
    },
    correctAnswer: "D",
    explanation:
      "A: 거부된 B: 환영받는 C: 강요된 D: 허가된. 여기서는 '허가된(permitted)'이 문맥상 가장 적절합니다. 교육을 완료하지 않은 직원들은 특정 구역에 접근할 '허가를 받지 못할' 것이라는 의미입니다.",
    translation:
      "출석은 필수이며, 이 교육을 완료하지 못한 직원들은 직장의 특정 구역에 접근하는 것이 허가되지 않을 것입니다.",
    type: "verb usage",
  },
  {
    id: 36,
    koreanQuestion:
      "일부로 우리의 ______ 노력 확장하기 위한 시장 도달을, 영업팀은 여행 중일 것이다 시카고로 다음달에 참석하기 위해 연례 소매 컨퍼런스 2025에.",
    question:
      "As part of our ______ efforts to expand market reach, the sales team will be traveling to Chicago next month to attend the Annual Retail Conference 2025.",
    choices: {
      A: "final",
      B: "random",
      C: "hesitant",
      D: "ongoing",
    },
    correctAnswer: "D",
    explanation:
      "A: 최종적인 B: 무작위의 C: 망설이는 D: 진행 중인. 여기서는 '진행 중인(ongoing)'이 문맥상 가장 적절합니다. 회사가 시장 도달 범위를 확장하기 위해 계속해서 노력하고 있음을 나타냅니다.",
    translation:
      "우리의 진행 중인 시장 도달 범위를 확장하기 위한 노력의 일환으로, 영업팀은 다음 달에 2025년 연례 소매 컨퍼런스에 참석하기 위해 시카고로 여행할 예정입니다.",
    type: "adjective usage",
  },
  {
    id: 37,
    koreanQuestion:
      "______ 여정 계획과 회의 일정은 공유될 것이다 1주일 출발하기 전",
    question:
      "A ______ itinerary and meeting schedule will be shared one week prior to departure.",
    choices: {
      A: "forgotten",
      B: "vague",
      C: "canceled",
      D: "detailed",
    },
    correctAnswer: "D",
    explanation:
      "A: 잊혀진 B: 모호한 C: 취소된 D: 상세한. 여기서는 '상세한(detailed)'이 문맥상 가장 적절합니다. 출발 전에 공유될 여정 계획과 회의 일정이 상세할 것임을 나타냅니다.",
    translation:
      "상세한 여정 계획과 회의 일정은 출발 1주일 전에 공유될 것입니다.",
    type: "adjective usage",
  },
  {
    id: 38,
    koreanQuestion:
      "잊지 마세요 그... 월간 프로젝트 검토 회의가 _______ 다음 주에",
    question:
      "Please be reminded that our monthly project review meeting ______ next week.",
    choices: {
      A: "is held",
      B: "was held",
      C: "holds",
      D: "will be held",
    },
    correctAnswer: "D",
    explanation:
      "A:(현재)열려진다 B:(과거에)열려졌다 C:(현재)열린다 D:(미래에) 열릴것이다",
    translation:
      "월간 프로젝트 검토 회의가 다음 주에 개최될 것을 상기시켜 드립니다.",
    type: "verb tense",
  },
  {
    id: 39,
    koreanQuestion:
      "알아두세요 그.. 예정된 유지보수가 ______ 회사의 네트워크 서버 그리고 IT 장비에 다음 주에",
    question:
      "Please be informed that scheduled maintenance ______ on the company's network servers and IT equipment next week.",
    choices: {
      A: "was performed",
      B: "is performing",
      C: "performs",
      D: "will be performed",
    },
    correctAnswer: "D",
    explanation:
      "A:(과거에) 수행됬다 B:(현재) 수행되는 중이다 C: (현재) 수행한다 D:(미래에) 수행될 것이다",
    translation:
      "회사의 네트워크 서버와 IT 장비에 대한 예정된 유지보수가 다음 주에 수행될 것임을 알려드립니다.",
    type: "verb tense",
  },
  {
    id: 40,
    koreanQuestion:
      "긴급한 IT 관련 작업은 완료되어야 합니다 유지보수 기간 전에",
    question:
      "Urgent IT-related tasks should be completed ______ the maintenance period.",
    choices: {
      A: "before",
      B: "across",
      C: "under",
      D: "despite",
    },
    correctAnswer: "A",
    explanation:
      "A: ~전에 B: ~에 걸쳐 C: ~아래에 D: ~에도 불구하고. 여기서는 '전에(before)'가 문맥상 가장 적절합니다. 긴급한 IT 작업은 유지보수 기간이 시작되기 전에 완료되어야 함을 나타냅니다.",
    translation: "긴급한 IT 관련 작업은 유지보수 기간 전에 완료되어야 합니다.",
    type: "preposition usage",
  },

  {
    id: 41,
    koreanQuestion:
      "우리는 알려드리고 싶어요 당신에게 중요한 업데이트를 회사의 원격 근무 정책, 그.. 시행될 예정인 4월 1일부터 2025년.",
    question:
      "We would like to inform you of an important update to the company's remote work policy, ______ will take effect starting April 1, 2025.",
    choices: {
      A: "who",
      B: "where",
      C: "what",
      D: "which",
    },
    correctAnswer: "D",
    explanation:
      "그.. 앞이 원격근무정책이고 그 ... 뒤에 주어자리가 비어있음으로 주격 관계대명사가 필요합니다. A: who는 사람을 가리키는 관계대명사, B: where는 장소를 가리키는 관계대명사, C: what은 선행사를 포함한 관계대명사, D: which는 사물을 가리키는 관계대명사입니다. 여기서는 'remote work policy'라는 사물을 가리키므로 which가 정답입니다.",
    translation:
      "저희는 회사의 원격 근무 정책에 대한 중요한 업데이트를 알려드리고자 합니다, 이는 2025년 4월 1일부터 시행될 예정입니다.",
    type: "relative pronoun",
  },
  {
    id: 42,
    koreanQuestion:
      "우리는 감사합니다 당신의 협조에 시행하는데 있어 이 새로운 정책을.",
    question:
      "We appreciate your cooperation ______ implementing this new policy.",
    choices: {
      A: "during",
      B: "by",
      C: "in",
      D: "over",
    },
    correctAnswer: "C",
    explanation:
      "A: during(~동안), B: by(~에 의해), C: in(~에서, ~하는 데 있어), D: over(~위에, ~에 걸쳐). 여기서는 'in'이 '~하는 데 있어서'의 의미로 사용되어 정책을 시행하는 과정에서의 협조를 나타내므로 가장 적절합니다.",
    translation:
      "우리는 이 새로운 정책을 시행하는 데 있어 당신의 협조에 감사드립니다.",
    type: "preposition usage",
  },
  {
    id: 43,
    koreanQuestion:
      "우리는 기쁩니다 초대하게 되어 당신을 연례 직원 감사 행사에, 그... 우리가 축하하는 노력 그리고 헌신 우리 직원들의",
    question:
      "We are excited to invite you to our Annual Employee Appreciation Event, ______ we celebrate the hard work and dedication of our employees.",
    choices: {
      A: "which",
      B: "when",
      C: "what",
      D: "where",
    },
    correctAnswer: "D",
    explanation:
      "그.. 앞에 감사행사로 감사행사를 설명하는 내용이 뒤에 옵니다. 이경우 앞의 내용을 꾸미는 관계부사 where이 옵니다 which가 오려면 at which(그 행사에서)가 와야 합니다.",
    translation:
      "우리는 여러분을 연례 직원 감사 행사에 초대하게 되어 기쁩니다, 그곳에서 우리는 직원들의 열심히 일한 것과 헌신을 축하합니다.",
    type: "relative adverb",
  },
  {
    id: 44,
    koreanQuestion:
      "이 시스템은 향상시킬 것이다 효율성과 정확성을 추적하는 데 근무 시간을",
    question:
      "This system will improve efficiency and accuracy ______ tracking work hours.",
    choices: {
      A: "in",
      B: "over",
      C: "without",
      D: "across",
    },
    correctAnswer: "A",
    explanation:
      "A: in(~에서, ~하는 데 있어), B: over(~위에, ~에 걸쳐), C: without(~없이), D: across(~을 가로질러). 여기서는 'in'이 '~하는 데 있어서'의 의미로 사용되어 근무 시간을 추적하는 과정에서의 효율성과 정확성 향상을 나타내므로 가장 적절합니다.",
    translation:
      "이 시스템은 근무 시간을 추적하는 데 있어 효율성과 정확성을 향상시킬 것입니다.",
    type: "preposition usage",
  },
  {
    id: 45,
    koreanQuestion:
      "우리는 기쁩니다 알리게되어 당신에게 그... 당사의 본사가 ________ 새 사무실 건물로 수용하기 위해 성장하는 팀을 그리고 제공하기 위해  더 나은 근무 환경을",
    question:
      "We are pleased to inform you that our company headquarters ______ to a new office building to accommodate our growing team and provide a better working environment.",
    choices: {
      A: "will be relocating",
      B: "was relocated",
      C: "has relocating",
      D: "are being relocate",
    },
    correctAnswer: "A",
    explanation:
      "A:(미래에)이전하는 중일 것이다 B:(과거에)이전됬다 C:조합될 수 없는 구조 D: relocated가 되야함 수동이 아니라 답이 안됨",
    translation:
      "우리는 당사의 본사가 성장하는 팀을 수용하고 더 나은 근무 환경을 제공하기 위해 새 사무실 건물로 이전할 것을 알려드리게 되어 기쁩니다.",
    type: "future progressive tense",
  },
  {
    id: 46,
    koreanQuestion:
      "2025년 3월 18일부터,  모든 영업 담당자는 _____ 해야 합니다 업데이트된 주문 처리 절차를 보장하기 위해 더 높은 정확성 재고 관리 및 배송 일정에 있어서.",
    question:
      "Effective March 18, 2025, all sales representatives must ______ to the updated order processing procedure to ensure greater accuracy in inventory management and delivery scheduling.",
    choices: {
      A: "respond",
      B: "react",
      C: "refer",
      D: "adhere",
    },
    correctAnswer: "D",
    explanation:
      "A: respond(대응하다), B: react(반응하다), C: refer(참조하다), D: adhere(준수하다). 여기서는 'adhere to'가 '~을 준수하다, ~을 지키다'의 의미로 사용되어 영업 담당자들이 새로운 절차를 따라야 한다는 의미를 나타내므로 가장 적절합니다.",
    translation:
      "2025년 3월 18일부터 모든 영업 담당자는 재고 관리 및 배송 일정의 정확성을 높이기 위해 업데이트된 주문 처리 절차를 준수해야 합니다.",
    type: "verb collocation",
  },
  {
    id: 47,
    koreanQuestion:
      "주문이 제출되면, 주문은 요구할것이다 승인을 지역 영업 감독자로부터 처리되기 전에 이행팀에 의해",
    question:
      "______ an order is submitted, it will require approval from the Regional Sales Supervisor before being processed by the fulfillment team.",
    choices: {
      A: "despite",
      B: "at",
      C: "once",
      D: "about",
    },
    correctAnswer: "C",
    explanation:
      "A: despite(~에도 불구하고), B: at(~에서), C: once(일단 ~하면), D: about(~에 관하여). 여기서는 'once'가 '일단 ~하면, ~하는 즉시'의 의미로 사용되어 주문이 제출된 후에 승인이 필요하다는 시간적 순서를 나타내므로 가장 적절합니다.",
    translation:
      "주문이 제출되면, 이행팀이 처리하기 전에 지역 영업 감독자의 승인이 필요합니다.",
    type: "subordinating conjunction",
  },
  {
    id: 48,
    koreanQuestion:
      "어떤 주문 불일치 또는 수정사항은 반드시 보고되어야 합니다 운영부서에 24시간이내에 제출의 .",
    question:
      "Any order discrepancies or modifications must be reported to the Operations Department ______ 24 hours of submission.",
    choices: {
      A: "within",
      B: "across",
      C: "despite",
      D: "under",
    },
    correctAnswer: "A",
    explanation:
      "A: within(~이내에), B: across(~을 가로질러), C: despite(~에도 불구하고), D: under(~아래에). 여기서는 'within'이 '~이내에'라는 의미로 시간적 제한을 나타내므로 가장 적절합니다. 주문 불일치나 수정 사항을 24시간 이내에 보고해야 한다는 의미입니다.",
    translation:
      "모든 주문 불일치 또는 수정 사항은 제출 후 24시간 이내에 운영 부서에 보고되어야 합니다.",
    type: "preposition",
  },
  {
    id: 49,
    koreanQuestion:
      "저희는 ____ 합니다  알리게 되어 당신에게 그...  예상치 못한 시스템 장애로 인해, 우리의 온라인 결제 처리 서비스가 일시적으로 이용 불가능할 것입니다 2025년 6월 6일 오전 10시(PST)부터",
    question:
      "We ______ to inform you that due to an unexpected system failure, our online payment processing service will be temporarily unavailable starting June 6, 2025, at 10:00 AM (PST).",
    choices: {
      A: "offer",
      B: "suggest",
      C: "regret",
      D: "consider",
    },
    correctAnswer: "C",
    explanation:
      "A: offer(제안하다), B: suggest(제안하다), C: regret(유감으로 생각하다), D: consider(고려하다). 여기서는 'regret'이 '유감으로 생각하다'의 의미로 사용되어 부정적인 소식을 전달할 때 사용하는 공식적인 표현이므로 가장 적절합니다.",
    translation:
      "저희는 예상치 못한 시스템 장애로 인해 2025년 6월 6일 오전 10시(PST)부터 온라인 결제 처리 서비스가 일시적으로 이용 불가능할 것임을 알려드리게 되어 유감입니다.",
    type: "verb expression",
  },
  {
    id: 50,
    koreanQuestion:
      " 대부분의 역할은 변경되지 않는 반면에, 특정 직원들은 재배치될 수 있다 다른 팀으로 비즈니스 요구에 따라.",
    question:
      "______ most roles will remain unchanged, certain employees may be reassigned to different teams based on business needs.",
    choices: {
      A: "Because",
      B: "Despite",
      C: "While",
      D: "Unless",
    },
    correctAnswer: "C",
    explanation:
      "A: Because(~때문에), B: Despite(~에도 불구하고), C: While(~하는 동안, ~인 반면), D: Unless(~하지 않는 한). 여기서는 'While'이 '~인 반면'이라는 의미로 대조를 나타내는 접속사로 사용되어, 대부분의 역할은 변경되지 않지만 일부 직원들은 재배치될 수 있다는 대조적인 상황을 표현하므로 가장 적절합니다.",
    translation:
      "대부분의 역할은 변경되지 않는 반면, 특정 직원들은 비즈니스 요구에 따라 다른 팀으로 재배치될 수 있습니다.",
    type: "subordinating conjunction",
  },
];
